import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Row, Button, Typography, Space } from 'antd'

export const UnsavedFormChangesModal = ({
  isVisible,
  handleCancel,
  handleConfirm,
  handleSave,
}) => (
  <Modal
    visible={isVisible}
    onCancel={handleCancel}
    title={null}
    footer={null}
    closable
    centered
  >
    <Typography.Text style={{ fontSize: 18 }}>
      This page is asking you to confirm that you want to leave — information you’ve
      entered may not be saved.
    </Typography.Text>

    <Row justify="end" style={{ marginTop: '24px' }}>
      <Space>
        <Button key="navigate" danger onClick={handleConfirm}>
          Leave page
        </Button>
        <Button key="save" type="primary" onClick={handleSave}>
          Save data
        </Button>
      </Space>
    </Row>
  </Modal>
)

UnsavedFormChangesModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default UnsavedFormChangesModal
